import { useUiStore } from 'app/core/store_v2/ui';
import { RootState } from 'app/store/rootReducer';
import { useSelector } from 'react-redux';

import { Box, ButtonBase, Drawer, Icon, SxProps, Theme, useTheme } from '@mui/material';

import { getNavigationConfig } from './Navigation/config';
import NavigationMobileToolBar from './Navigation/NavigationMobileToolBar';

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    root: {
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      justifyContent: 'center',
      bottom: '0',
      background: theme.palette.background.paper,
      zIndex: 5,
    },
    mobileAppBar: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      minHeight: '80px',
      alignItems: 'flex-start',
      boxShadow: '0px -3px 5px rgba(52, 61, 75, 0.05)',
    },

    moreButton: {
      display: 'flex',
      flexDirection: 'column',
      color: theme.palette.primary.main,
      marginTop: 0,
      paddingTop: 2,
      paddingLeft: 0,
      fontSize: '12px',
      alignItems: 'center',
      width: '70px',
      height: '100%',

      '&.active': {
        '&:after': {
          width: '100%',
          height: '4px',
          position: 'absolute',
          right: 0,
          top: 0,
          content: '""',
          display: 'block',
          background: theme.palette.secondary.main,
          borderRadius: theme.shape.borderRadius,
        },
      },

      '& span:first-of-type': {
        fontSize: '26px',
        margin: 'auto',
        marginBottom: '5px',
        height: '24px',
      },
    },
    navigationContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      width: '100%',
      overflow: 'auto',
    },

    navbarToolbar: {
      display: 'flex',
      overflow: 'hidden',
      flexDirection: 'column',
      flex: '1 1 auto',
      width: '100%',
      minWidth: '100%',
      bottom: '80px',
      zIndex: 3,
      transition: theme.transitions.create(['width', 'min-width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
    },
  };
};

export default function NavbarMobileLayout() {
  const { bottomUserMenu, setUserMenu } = useUiStore();

  const theme = useTheme();
  const styles = getStyles(theme);
  const { user, currentApp } = useSelector((state: RootState) => state.auth);

  const handleClick = () => {
    if (bottomUserMenu) {
      handleClose();
      return;
    }
    setUserMenu('top', false);
    setUserMenu('bottom', true);
  };

  const handleClose = () => {
    setUserMenu('bottom', false);
  };

  if (!user) {
    return null;
  }

  return (
    <Box sx={styles.root}>
      <Box sx={styles.mobileAppBar}>
        <NavigationMobileToolBar
          mode="toolBar"
          navigation={getNavigationConfig(user, currentApp)}
        >
          <ButtonBase
            component={'span'}
            onClick={handleClick}
            className={bottomUserMenu ? 'active' : ''}
            sx={styles.moreButton}
          >
            <Icon>menu</Icon>
            More
          </ButtonBase>
        </NavigationMobileToolBar>
      </Box>
      <Drawer
        anchor="bottom"
        variant="temporary"
        open={bottomUserMenu}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        PaperProps={{
          sx: styles.navbarToolbar,
        }}
      >
        <Box sx={styles.navigationContainer} onClick={handleClose}>
          <NavigationMobileToolBar
            mode="nav"
            navigation={getNavigationConfig(user, currentApp)}
          />
        </Box>
      </Drawer>
    </Box>
  );
}
